export type AppClientConfig = {
  paymentGateway?: string;
};

const DEFAULT_CLIENT_CONFIG: AppClientConfig = {
  paymentGateway: String(import.meta.env.VITE_PAYMENT_GATEWAY || localStorage.getItem('paymentGateway') || 'phonepe').toLowerCase()
};

export async function loadClientConfig(): Promise<AppClientConfig> {
  const path = import.meta.env.VITE_CLIENT_CONFIG_PATH as string | undefined;
  if (!path?.trim()) {
    return DEFAULT_CLIENT_CONFIG;
  }

  try {
    const response = await fetch(path.trim(), { cache: 'no-store' });
    if (!response.ok) {
      return DEFAULT_CLIENT_CONFIG;
    }

    const json = (await response.json()) as AppClientConfig;
    return {
      paymentGateway: String(json?.paymentGateway || DEFAULT_CLIENT_CONFIG.paymentGateway || 'phonepe').toLowerCase()
    };
  } catch {
    return DEFAULT_CLIENT_CONFIG;
  }
}

export function getDefaultPaymentGateway(): string {
  return String(DEFAULT_CLIENT_CONFIG.paymentGateway || 'phonepe').toLowerCase();
}